
export const Header = (props) => {
    const {header} = props
    return (
        <h1 style={props.style ? props.style : {}}>{header}</h1>
    )
};

export const Paragraph = (props) => {
    const {text} = props
    if(text) {
        return (
            text.map((t,index) => <p style={props.style ? props.style : {}} key={index} dangerouslySetInnerHTML={{__html:t}}></p>)
        )
    }

    return null
}

const buttonTypeMapping = (buttonType) => {
    let className = ""
    switch(buttonType) {
        case 'regular_primary' :
            className = "btn btn-primary"
            break
        case 'regular_success' : 
            className = "btn btn-success"
            break
        case "regular_disabled" : 
            className = "btn disabled"
            break
        case "regular_clear" : 
            className = "btn btn-clear"
            break
        case "regular_link" : 
            className = "btn btn-link"
            break
        case "regular_warning" : 
            className = "btn btn-warning"
            break
        case "regular_danger" : 
            className = "btn btn-danger"
            break  
        case "small_primary" : 
            className = "btn-sm btn-default"
            break
        default : 
            className = ""
    }

    return className
}

export const LoginButton = (props) => {
    return (
        <button
            disabled={props.disabled} 
            id="loginButton"
            onClick={props.onClick}
            className="loginButton"
            style={Object.assign({cursor: "pointer"},props.style)}>
                <span className="mainHeader">{props.header}</span>
                <br />
                <span className="subHeader">
                    {props.subHeader}
                </span>
            </button>
    )
}

export const BackButton = (props) => {
    const title = props.title ? props.title : "Back"
    return (
        <button
            id={props.id}
            key={props.key} 
            className={(props.className ? props.className : "") + " appNavigationButton"}  
            onClick={(e) => {
                    e.preventDefault()
                    if(props.onClick) 
                        props.onClick()
            }}
            style={props.style}>
            {props.text 
                ? <span>{props.text}</span> 
                    : <><span>{"< "}</span><u>{title}</u></>}
        </button>
    )
}

export const NavigationLinkButton = (props) => {
    return (
        <button
            id={props.id}
            key={props.key} 
            className={(props.className ? props.className : "") + " appNavigationButton"}  
            onClick={(e) => {
                e.preventDefault()
                if(props.onClick) 
                    props.onClick()
        }}
            style={props.style}>
            <u>{props.text}</u>
        </button>
    )
}

export const Button = (props) => {
    let className = buttonTypeMapping(props.buttonType)
    if(props.className) { 
        className += " " + props.className
    }
    const {showSpinner} = props
    
    return (
        <button 
            id={props.id}
            key={props.key}
            className={className} 
            onClick={props.onClick ? props.onClick : e => {}}
            style={Object.assign({},props.style)}
            disabled={props.disabled}>
            {showSpinner ? <span className="spinner-border" style={{width: "1.4rem", height: "1.4rem", borderWidth: ".2em"}} role="status" aria-hidden="true"></span> : ""} 
            <span className={showSpinner ? "leftMarginNormal" : ""} style={{paddingTop: "2px"}}>{props.text}</span>
        </button>
    )
}

export const SubHeader = (props) => {
    const {subHeader} = props
    return (
        <h2 style={props.style ? props.style : {}}>{subHeader}</h2>
    )
}

export const LineSeperator = (props) => {

    const defaultStyle = {
        borderColor : "#0058a4"
    }

    return (
        <hr style={Object.assign(defaultStyle,props.style ? props.style : {})} />
    )
}

export const CorrespondenceAddressComponent = () => {
    return (
        <>
        <div className="row">
            <div className="col-lg-8">
                <h4>Mail</h4>
                <div itemProp="address" itemType="http://schema.org/PostalAddress">
                    <p>
                        <span itemProp="name">
                            Service Nova Scotia, Business Licensing
                        </span>
                        <br />
                        <span itemProp="address1">
                        7th Floor North, Maritime Center 
                        </span>
                        <br />
                        <span itemProp="address2">
                        1505 Barrington Street
                        </span>
                        <br />
                        <span itemProp="postOfficeBoxNumber">P.O.Box 1003</span>
                        <br />
                        <span itemProp="addressLocality">Halifax NS</span>
                        <span itemProp="postalCode">&nbsp;B3J 2X1</span>
                        <br />
                    </p>
                </div>
            </div>
        </div>
        <div className="row">
            <div className="col-lg-8">
                <h4>Courier</h4>
                <div itemProp="address" itemType="http://schema.org/PostalAddress">
                    <p>
                        <span itemProp="name">
                            Service Nova Scotia, Business Licensing
                        </span>
                        <br />
                        <span itemProp="address1">
                        7th Floor North, Maritime Center 
                        </span>
                        <br />
                        <span itemProp="address2">
                        1505 Barrington Street
                        </span>
                        <br />
                        <span itemProp="addressLocality">Halifax NS</span>
                        <span itemProp="postalCode">&nbsp;B3J 2X1</span>
                        <br />
                    </p>
                </div>
            </div>
        </div>
        </>
    )
}

export function ErrorMark() { 
    return (
        <span className="has-error" style={{marginLeft: "6px"}}>
            <i className="fa fa-exclamation-circle error-indicator errorAlert" aria-hidden="true"></i>
        </span>
    )
}

export function ErrorWithString(str, styles = {}) { 
    return (
        <div style={styles}>
            <i className="fa fa-exclamation-circle error-indicator errorAlert errorMark" aria-hidden="true"></i>
            <span className="ns-visually-hidden">Error:</span>
            {str}
        </div>
    )
}

export function SuccessWithString(str, styles = {}) { 
    return (
        <div style={styles}>
            <i className="fa fa-check-circle" style={{marginRight: "5px"}} aria-hidden="true"></i>
            <span className="ns-visually-hidden">Success:</span>
            {str}
        </div>
    )
}

export function InfoWithString(str, styles = {}) { 
    return (
        <div style={styles}>
            <i className="fa fa-exclamation-circle" style={{marginRight: "5px"}} aria-hidden="true"></i>
            <span className="ns-visually-hidden">Info:</span>
            {str}
        </div>
    )
}

export function MortgageRegulationContacts(props) {
    return (
        <div className="help-block ns-error-message field-validation-error">
            <p>{props.message}</p>
            <p>Email : MortgageRegulation@novascotia.ca</p>
            <p>Phone: 902-424-5552</p>
            <p>Toll-Free: 1-800-670-4357</p>
        </div>
    )
}

export function MaxFileSizeUploadInstructionText() {
    return (
        <div className="row">
            <div className="col-xs-12 col-lg-9">
                <Paragraph
                    style={{ paddingBottom: "20px" }}
                    id="upload-file-instruction-text"
                    text={[
                        "The maximum file size allowed is 15 MB per file and 50 MB total. " + 
                        "Supported document types are Microsoft Word, Microsoft Office Excel, " + 
                        "or Adobe PDF.  All digital files must be in an uncompressed format, " + 
                        "i.e no zip or ARC files.",
                    ]}
                />
            </div>
        </div>
    )
}

export function MaxFileSizeUploadInstructionTextForSingleFile() {
    return (
        <div className="row">
            <div className="col-xs-12 col-lg-9">
                <Paragraph
                    style={{ paddingBottom: "20px" }}
                    id="upload-file-instruction-text"
                    text={[
                        "The maximum file size allowed is 15 MB per file. " + 
                        "Supported document types are Microsoft Word, Microsoft Office Excel, " + 
                        "or Adobe PDF.  All digital files must be in an uncompressed format, " + 
                        "i.e no zip or ARC files.",
                    ]}
                />
            </div>
        </div>
    )
}

export const MainSeparator = () => {
    return (
      <hr
        className="bottomMarginNormal"
        style={{ borderColor: "#777", borderWidth: "3px", width: "85%", margin: "10px 0px" }}
      />
    );
  };

export const SubSeparator = () => {
    return (
        <hr
            className="bottomMarginNormal"
            style={{
                borderColor: "#0058a466",
                borderWidth: '3px',
                width: "60%",
                marginLeft: "0px"
            }}
        />
    )
}

export const LoadingIndicator = ({isLoading}) => {
    if(!isLoading) {
        return null
    }

    return (
        <div style={{display:"flex", justifyContent:"center"}}>
            <span className="spinner-border" style={{width: "1.4rem", height: "1.4rem", borderWidth: ".2em"}} role="status" aria-hidden="true" />
        </div>
    )
}
